// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"21d394ad","139":"483a1e44","193":"39a0d7fb","606":"071f43f5","959":"23f98ad9","960":"77d5e7d8"}[chunkId] + ".chunk.js";
};